import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import highlight from 'flarum/common/helpers/highlight';

export default class GroupsSearchItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.query = this.attrs.query;
    this.group = this.attrs.group;
  }

  view() {
    const group = this.group;
    const query = this.query;

    return (
      <li className="GroupSearchResult" data-index={'groups' + group.id}>
        <Link href={app.route('groupDetail', { id: group.id })}>
          <div className="GroupSearchResult-content">
            {group.cover_image && (
              <div className="GroupSearchResult-cover">
                <img 
                  src={group.cover_image.startsWith('http') ? group.cover_image : (app.forum.attribute('baseUrl') || '') + '/' + group.cover_image} 
                  alt={group.name} 
                />
              </div>
            )}
            <div className="GroupSearchResult-info">
              <div className="GroupSearchResult-name">
                {highlight(group.name || '', query)}
              </div>
              {group.description && (
                <div className="GroupSearchResult-description">
                  {highlight(group.description.substring(0, 100), query, 100)}
                </div>
              )}
              {group.member_count !== undefined && (
                <div className="GroupSearchResult-meta">
                  {app.translator.trans('tf-custom-header.forum.search.group_members', {
                    count: group.member_count,
                  })}
                </div>
              )}
            </div>
          </div>
        </Link>
      </li>
    );
  }
}
